import { ExportCreateResponse, ExportStatus } from '@siteday/shared';

import { api } from './client';

/** Full-export job (doc 05 Exports, doc 09 ZIP); shapes come from the shared contract. */
export const requestExport = () => api.post('/exports', undefined, ExportCreateResponse);
export const getExport = (id: string) => api.get(`/exports/${id}`, ExportStatus);
